import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=7feb87d3"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7feb87d3')) {
      api.createRecord('7feb87d3', component.options)
    } else {
      api.reload('7feb87d3', component.options)
    }
    module.hot.accept("./Coin.vue?vue&type=template&id=7feb87d3", function () {
      api.rerender('7feb87d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/Coin.vue"
export default component.exports